import React from 'react'
import Button from '../../../../components/Button'
import { useIndividualizationContext } from '../../../../contexts/individualizationContext'
import { useTranslation } from 'react-i18next'
import styles from './NavButtons.module.css'
import cx from 'classnames'
import { useNavigate } from 'react-router-dom'

const NavButtons: React.FC<{ method: 'store' | 'update' | 'duplicate' }> = ({
    method,
}) => {
    const {
        activeStep,
        changeActiveStep,
        steps,
        completedSteps,
        submitIndividualization,
    } = useIndividualizationContext()
    const { t } = useTranslation(['individualization'])
    const navigate = useNavigate()

    const handleBackButtonClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        if (activeStep > 0) changeActiveStep(activeStep - 1)
        ;(e.target as HTMLButtonElement).blur()
    }

    const handleNextButtonClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        if (activeStep < steps.length - 1) {
            changeActiveStep(activeStep + 1)
        }
        ;(e.target as HTMLButtonElement).blur()
    }

    const handleSubmitButtonClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        submitIndividualization(method).then(() => {
            navigate('/individualizations')
            ;(e.target as HTMLButtonElement).blur()
        })
    }

    return (
        <div className={cx(styles['nav-buttons-wrapper'])}>
            <Button
                text={t('nav.back')}
                disabled={activeStep < 1}
                fn={handleBackButtonClick}
                hierarchy={'primary'}
                classes={'zr-my-2'}
            />
            {activeStep < steps.length - 1 ? (
                <Button
                    text={t('nav.next')}
                    fn={handleNextButtonClick}
                    hierarchy={'primary'}
                    classes={'zr-my-2'}
                    disabled={activeStep >= steps.length - 1}
                />
            ) : (
                <Button
                    text={t('nav.submit')}
                    fn={handleSubmitButtonClick}
                    hierarchy={'primary'}
                    classes={'zr-my-2'}
                    disabled={completedSteps.length !== steps.length}
                />
            )}
        </div>
    )
}

export default NavButtons
